/**
 * Wraps all Course components in a default container. If you want to
 * give all Course views a sidebar for example, you would set that here. 
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import DefaultLayout from "../../../global/components/DefaultLayout.js.jsx";

import CloseWrapper from '../../../global/components/helpers/CloseWrapper.js.jsx';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

class CourseModuleOptions extends Base {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    }
    this._bind(
      '_handleCloseOptionsModal'
      , '_handleOpenOptionsModal'
      , '_moveUp'
      , '_moveDown'
      , '_moveToTop'
      , '_removeItem'
    )
  }

  _handleCloseOptionsModal(e) {
    e.stopPropagation();
    this.setState({
      isOpen: false
    })
  }

  _moveUp(e, index) {
    this.props.moveUp(index); 
    this._handleCloseOptionsModal(e); 
  }

  _moveDown(e, index) {
    this.props.moveDown(index); 
    this._handleCloseOptionsModal(e); 
  }

  _moveToTop(e, index) {
    this.props.moveToTop(index); 
    this._handleCloseOptionsModal(e); 
  }

  _removeItem(e, index) {
    this.props.removeItem(index); 
    this._handleCloseOptionsModal(e); 
  }

  _handleOpenOptionsModal(e) {
    // e.stopPropagation();
    // this.setState({
    //   isOpen: false
    // }, () => this.props.handleOpenQuickTaskModal())
  }

  render() {
    const { item, index, reorderable, moveUp, moveDown, removeItem, moveToTop, displayKey, selectedItems } = this.props; 
    const { isOpen } = this.state; 
    return (
      <div key={index}  className="-item  -left">
        <div className="text">
          {item[displayKey] + "    "}
        </div>
        <div className="-checkbox" onClick={() => this.setState({isOpen: true})}>
          <div style={{position: "relative", height: "100%", width: "100%"}}>
            <CloseWrapper
              isOpen={(this.state.isOpen)}
              closeAction={this._handleCloseOptionsModal}
            />
            <i className="far fa-ellipsis-v"></i>

            {isOpen ? 
              <CSSTransition
                classNames="dropdown-anim"
                timeout={250}
              >
                <div className="dropMenu -options-menu">
                  { index > 0 && reorderable ? 
                    <div>
                      <li className="-option">
                        <a onClick={(e) => this._moveUp(e, index)}>Move up</a>
                      </li>
                    </div>
                  : null
                  }
                  { index < (selectedItems.length - 1) && reorderable ? 
                    <div>
                      <li className="-option">
                        <a onClick={(e) => this._moveDown(e, index)}>Move down</a>
                      </li>
                    </div>
                  : null 
                  }
                  { index > 0 ? 
                    <div>
                      <li className="-option">
                        <a onClick={(e) => this._moveToTop(e, index)}>Move to top</a>
                      </li>
                    </div>
                  : null 
                  }
                  <div>
                    <li className="-option">
                      <a className="-delete-link" onClick={(e) => this._removeItem(e, index)}>Remove item</a>
                    </li>
                  </div>
                </div>
              </CSSTransition>
            : null
            }
          </div>
        </div>
      </div>
    )
  }
}

export default CourseModuleOptions;



// WEBPACK FOOTER //
// modules/course/components/CourseModuleOptions.js.jsx